// @ts-nocheck
import { FC } from "react";
import { useStepDrawerController } from "hooks";
import StepperDrawerLayout, {
  IStepItem
} from "components/layouts/StepperDrawerLayout/StepperDrawerLayout";

// STEPS
import EmailVerificationForm from "components/forms/FietsgestolenForms/EmailVerificationForm";
import CodeVerificationReportTheftForm from "components/forms/FietsgestolenForms/CodeVerificationReportTheftForm";
import ReportTheftNewSuccessSection from "components/sections/FietsgestolenSections/ReportTheftNewSuccessSection";

const INITIAL_STEPS: Array<IStepItem> = [
  { index: 0, name: "E-mail verificatie", isActive: true, isCompleted: false },
  { index: 1, name: "Code verificatie", isActive: false, isCompleted: false },
  { index: 2, name: "Succes", isActive: false, isCompleted: false }
];

const ReportTheftNewForm: FC = () => {
  const { steps, activeStepIndex, onCompletedStepClick, gotoNextStep } =
    useStepDrawerController(INITIAL_STEPS);

  return (
    <StepperDrawerLayout
      size={"extraLarge"}
      appLogoSize={"extraLarge"}
      isMobileDrawerOpen={false}
      appLogoType={"fietsgestolen"}
      steps={steps}
      onCompletedStepClick={onCompletedStepClick}
    >
      {activeStepIndex === 0 && (
        <EmailVerificationForm gotoNextStep={gotoNextStep} />
      )}
      {activeStepIndex === 1 && (
        <CodeVerificationReportTheftForm gotoNextStep={gotoNextStep} />
      )}
      {activeStepIndex === 2 && <ReportTheftNewSuccessSection />}
    </StepperDrawerLayout>
  );
};

export default ReportTheftNewForm;
